import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import LightBlueButton from '../../../../Common/LightBlueButton';

function HintCard({ children, src }) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      height="20vh"
      width="15vw"
    >
      <Box
        style={{ border: '1px solid #CCCCCC' }}
        m={1}
        flexGrow={2}
      >
        <img src={src} alt="" style={{ objectFit: 'contain', width: '100%', height: '100%' }} />
      </Box>
      <Box
        m={1}
        // flexGrow={1}
      >
        <a href="https://www.hhgalaxy.com.tw/qa" target="_blank" rel="noopener noreferrer">
          <LightBlueButton>
            {children}
          </LightBlueButton>
        </a>
      </Box>
    </Box>
  );
}

HintCard.propTypes = {
  children: PropTypes.node,
  src: PropTypes.string,
};

HintCard.defaultProps = {
  children: null,
  src: '',
};

export default HintCard;
